import {
  AsphaltLotDate,
  AsphaltLotId,
  AsphaltMixDesign,
  AsphaltMixGrade,
  AsphaltPlacementType,
  AsphaltShortName,
} from './asphalt'
import {
  CASPackageName,
  CASPackageNumber,
  CASSubtype,
  CASType,
  CASCreatedDate,
  CASDispositionDate,
} from './cas'
import { PhotoSequenceNumber } from './classless'
import {
  ConcreteClassification,
  ConcreteClientMixDesign,
  ConcreteMixDesign,
  ConcretePlacementDate,
  ConcretePlacementType,
  ConcreteShortName,
} from './concrete'
import {
  DailyInspectionWorkType,
  DailyInspectionShortName,
  DailyControlPointDate,
  DailyControlPointId,
  DailyInspectionDate,
  DailyInspectionId,
  DailyPunchListDate,
  DailyPunchListId,
} from './dailyInspection'
import {
  DensityLotDate,
  DensityLotId,
  DensityLotMaterialSource,
  DensityLotClassification,
  DensityLotMaterialSection,
  DensityLotShortName,
} from './density'
import { ProjectName, ClientProjectNumber, ClientProjectName } from './project'

export const projects = [ProjectName, ClientProjectNumber, ClientProjectName]
export const densities = [
  DensityLotDate,
  DensityLotId,
  DensityLotMaterialSource,
  DensityLotClassification,
  DensityLotMaterialSection,
  DensityLotShortName,
]
export const classless = [PhotoSequenceNumber]
export const asphalts = [
  AsphaltLotDate,
  AsphaltLotId,
  AsphaltMixDesign,
  AsphaltMixGrade,
  AsphaltPlacementType,
  AsphaltShortName,
]
export const workTypes = [DailyInspectionWorkType, DailyInspectionShortName]
export const punchLists = [DailyPunchListDate, DailyPunchListId]
export const inspections = [DailyInspectionDate, DailyInspectionId]
export const controlPoints = [DailyControlPointDate, DailyControlPointId]
export const concretes = [
  ConcreteClassification,
  ConcreteClientMixDesign,
  ConcreteMixDesign,
  ConcretePlacementDate,
  ConcretePlacementType,
  ConcreteShortName,
]
export const constructionSubmittals = [
  CASPackageName,
  CASPackageNumber,
  CASType,
  CASSubtype,
  CASCreatedDate,
  CASDispositionDate,
]
